import i18next from 'src/i18n';
import { IAgendaStep } from 'src/types';

export const agenda: IAgendaStep[] = [
    {
      index: 0,
      title: i18next.t("lobby"),
      description: i18next.t("lobby_description"),
      percentage: 0,
    },
    {
      index: 1,
      title: i18next.t("next_meeting"),
      description: i18next.t("next_meeting_description"),
      percentage: 5,
    },
    {
      index: 2,
      title: i18next.t("agenda"),
      description: i18next.t("agenda_description"),
      percentage: 5,
    },
    {
      index: 3,
      title: i18next.t("critical_questions"),
      description: i18next.t("critical_questions_description"),
      percentage: 15,
    },
    {
      index: 4,
      title: i18next.t("deliverables_board"),
      description: i18next.t("deliverables_board_description"),
      percentage: 15,
    },
    {
      index: 5,
      title: i18next.t("questions_board"),
      description: i18next.t("questions_board_description"),
      percentage: 15,
    },
    {
      index: 6,
      title: i18next.t("questions_before"),
      description: i18next.t("questions_before_description"),
      percentage: 15,
    },
    {
      index: 7,
      title: i18next.t("questions_during"),
      description: i18next.t("questions_during_description"),
      percentage: 10,
    },
    {
      index: 8,
      title: i18next.t("questions_future"),
      description: i18next.t("questions_future_description"),
      percentage: 15,
    },
    {
      index: 9,
      title: i18next.t("close_meeting"),
      description: i18next.t("close_meeting_description"),
      percentage: 5,
    }
  ];